import * as actionTypes from './actionTypes';

export const onGetMyInfoDataSuccess = (response)=>({
    type: actionTypes.GET_MYINFO_DATA_SUCCESS,
    response: response
});

export const onGetMyInfoDataFailed = (error) => ({
    type:actionTypes.GET_MYINFO_DATA_FAILED,
    error
});

export const onGetMyInfoDataStart = (payload) =>({
    type: actionTypes.GET_MYINFO_DATA,
    payload
});

export const onAuthorizeMyInfoDataStart = (sessionId, includeCpf) => ({type: actionTypes.AUTHORIZE_MYINFO, sessionId, includeCpf});
